/**
 * Session token storage helper for cross-domain deployments.
 *
 * When the frontend and backend are on different domains (e.g. autoqa.tech vs
 * autoqa-stability.emergent.host), browsers block the SameSite=None session
 * cookie as a third-party cookie. The backend already accepts the same
 * session_token via `Authorization: Bearer <token>`, so we persist it here
 * and attach it on every axios request.
 */

const KEY = "autoqa_session_token";

export function getSessionToken() {
  try {
    return localStorage.getItem(KEY);
  } catch {
    return null;
  }
}

export function setSessionToken(token) {
  try {
    if (token) {
      localStorage.setItem(KEY, token);
    }
  } catch {
    // storage unavailable (private mode) - cookie fallback will still work for same-domain
  }
}

export function clearSessionToken() {
  try {
    localStorage.removeItem(KEY);
  } catch {
    // ignore
  }
}
